export const vinDecoderPageStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  headerContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'space-between',
    alignItems: { xs: 'flex-start', sm: 'center' },
    gap: '20px',
    marginBottom: '20px',
  },
  headerTitle: {
    fontWeight: 'bold',
    fontSize: '20px',
  },
  vinInputRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    marginBottom: '20px',
  },
  contentBox: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: 'flex-start',
    gap: { xs: '20px', sm: '30px' },
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    width: { xs: '100%', sm: 'calc(33.33%)' },
    gap: '20px',
  },
  card: {
    borderRadius: '10px',
    padding: '15px 20px',
    border: '1px solid #ccc',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    fontSize: '1.8rem',
    textTransform: 'uppercase',
    marginBottom: '10px',
    fontFamily: 'Saira Extra Condensed',
  },
  detailBox: {
    display: 'flex',
    marginBottom: '10px',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '20px',
  },
  detailTitle: {
    textTransform: 'uppercase',
    color: '#666',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    fontFamily: 'Roboto Condensed',
  },
  detailTextFieldInput: {
    fontWeight: '500',
    fontSize: '1.1rem',
  },
  detailValue: {
    fontWeight: '500',
    fontSize: '1.1rem',
    textAlign: 'end',
  },
};
